import { getDownloadParts, getDownloadUrl } from './exportJob';

/**
 * Download de um arquivo de exportação completa. A URL é a assinada pelo
 * bucket (B2): navegar até ela baixa o ZIP e a página continua onde está.
 */
export const downloadExportFile = (url) => {
    window.location.href = url;
};

/**
 * Download automático quando a exportação termina: só o primeiro arquivo (o
 * navegador pede permissão para vários downloads sem clique, e navegações
 * seguidas se cancelam); as demais partes ficam nos botões do histórico.
 * Devolve quantos arquivos a exportação tem (0 quando não há o que baixar).
 */
export const autoDownloadExport = (job) => {
    const url = getDownloadUrl(job);
    if (!url) return 0;
    downloadExportFile(url);
    return Math.max(getDownloadParts(job).length, 1);
};
